import { isSmallView } from 'widgets/toolbox/viewtype';
import { getContentByUrl } from 'widgets/toolbox/ajax';
import { TWidget } from 'widgets/Widget';

/**
 * @description Wanna Button implementation
 * @param Widget Base widget for extending
 * @returns Wanna Button widget
 */
function WannaARButtonClassCreator(Widget: TWidget) {
    class WannaARButton extends Widget {
        prefs() {
            return {
                iframeUrl: '',
                modalUrl: '',
                ...super.prefs()
            };
        }

        init(): void {
            super.init();
        }

        /**
         * @description Generates url to trigger the Wanna modal
         * @param isMobileView - whether the modal is loading on a mobile view
         */
        generateModalUrl(isMobileView: boolean): string {
            const baseUrl = this.prefs().modalUrl;
            const iframeUrl = this.prefs().iframeUrl;
            let queryString = '?iframeUrl=' + encodeURIComponent(iframeUrl);

            if (isMobileView) {
                queryString += '&isMobileView=true';
            }

            return baseUrl.concat(queryString);
        }

        /**
         * @description Triggers functions to either append Wanna Iframe to product image or show dialog
         */
        showWannaIFrame(): void {
            const wannaModalElem = document.querySelector('.b-product_wanna-iframe') as HTMLElement;

            if (wannaModalElem?.hidden) {
                this.eventBus().emit('wannaiframe.show');

                return;
            }

            if (isSmallView()) {
                this.appendWannaIframe();
            } else {
                const url = this.generateModalUrl(false);

                if (!url) {
                    return;
                }

                this.eventBus().emit('dialogshow', {
                    url: url,
                    wrapperClasses: 'm-wanna',
                    ariaLabel: 'Try me On'
                });
            }
        }

        /**
         * @description Appends Wanna IFrame to product image
         */
        async appendWannaIframe() {
            const parent = document.querySelector('[data-id="imagesCarousel"]') as HTMLDivElement;
            const url = this.generateModalUrl(true);
            const response = await getContentByUrl(url);
            const temp = document.createElement('div');

            temp.innerHTML = response;
            const elem = temp.firstChild;

            if (elem) {
                parent.append(elem);
            }
        }
    }

    return WannaARButton;
}

export type TWannaARButton = ReturnType<typeof WannaARButtonClassCreator>;

export type TWannaARButtonInstance = InstanceType<TWannaARButton>;

export default WannaARButtonClassCreator;
